<template>
 <div class="shopping-cart">
     <hr/>
     <div v-if="product_info" class="margin-top-50 pretty-banner">
        <h5 style="font-size:18px;">Same product but different variations</h5>
        <p >if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.</p>
        <p class="center"><i class="fa fa-arrow-right"></i><a :href="product_url">Proceed to this Product's View </a></p>
     </div>
    <div v-if="!product_info" class="cart-ship-info register col-sm-10 contact_form">
       
        <h6>New Gallery</h6>
            <form>
                <ul class="row">
                 
                    <li class="col-sm-12">
                        <label> *Name
                            <input type="text" v-model="gallery.gallery_name" value="" placeholder="Gallery Name">
                        </label>
                    </li>
                    
                   <!-- <li class="col-sm-12">
                        <label> *Category 
                            <input type="text" v-model="gallery.gallery_name" value="" placeholder="Gallery Name">
                        </label>
                    </li> -->

                    <li class="col-md-12">
                          <label> *Description
                            <textarea  v-model="gallery.gallery_description"></textarea>
                          </label>
                    </li>
                   
                </ul>
                <h6>Add a Post to Gallery</h6>
                <div>
                    <ul class="row">
                    
                        <li class="col-sm-12">
                            <label> *Caption
                                <input type="text" v-model="post.post_caption" value="" placeholder="">
                            </label>
                        </li>
                        
                    
                        <li class="col-md-12">
                            <label> *Details
                                <textarea  v-model="post.post_details"></textarea>
                            </label>
                        </li>
                        <!-- <h6>Add a product Item, you can add more items later</h6> -->

                        
                        
                        <li class="col-md-12">
                            <p class="p-tiny-info">{{max_media_info}}</p>
                            <div class="upload-btn-wrapper" style="cursor:pointer">
                                <!-- <img class="img_responsive"/> -->
                                <button type="button" class="upload-btn">Add Image / Video</button>
                                <input type="file" id="input-file" @change="onFileChange($event)" accept="video/*,image/*" capture/>
                                <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>                                                                                                                                                                                                                                                                                                                                        
                            </div>
                            <p class="data-error-message">{{data_media_error_message}}</p>
                        </li>
                        <li class="col-md-6">
                            <p class="data-error-message">{{data_error_message}}</p>
                            <p class="data-success-message">{{data_success_message}}</p>
                            <div v-if="action_loading" class="loading-sm"></div>
                            <button :disabled="disable_btn" type="button" class="btn" @click="addGallery">Add</button>
                        </li>
                    </ul>
                </div>
        </form>
        </div>
    </div>
</template>
<style>
    .pretty-banner{
        border: 1px solid #b3b9c0;
        padding: 1.2em;
        background: #83ee91;
        line-height: 1.8;
        border-radius: 5px;
        color:#fff; 
    }
    .pretty-banner p a:hover{
        color: #ff0000;
    }
    /*form*/
    .contact_form li {
        text-align: left;
        margin-bottom: 10px;
    }
    .contact_form li input {
        display: inline-block;
        width: 100%;
        height: 35px;
        padding: 0 10px;
        margin-top: 5px;
    }
    .contact_form li .error {
        border: 1px solid #CCC;
        border-bottom: 1px solid red;
    }
    .contact_form li .form-control {
        height: 45px;
        border: 1px solid #2d3a4b;
        box-shadow: none;
        border-radius: 0px;
        background: #fff;
    }
    .contact_form li textarea {
        height: 140px !important;
        width: 340px;
        margin-top: 10px;
    }
    .contact_form li .btn {
        text-transform: uppercase;
        padding: 0px 40px;
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        margin-top: 15px;
    }
    .contact_form li .btn:hover {
        background: #ffffff;
    }
    .contact-form .tittle {
        text-align: center;
    }
    .contact-form .tittle hr {
        width: 28px;
        height: 5px;
        margin: 15px auto;
        background: #448aff;
        border: none;
    }
    .contact-form .tittle p {
        text-transform: none;
        font-size: 16px;
    }
    .contact-form label {
        font-weight: normal;
        color: #2d3a4b;
        font-size: 12px;
        text-transform: uppercase;
        display: inline-block;
        width: 100%;
        margin: 0px;
        margin-bottom: 13px;
    }
    .contact-form textarea {
        display: inline-block;
        width: 100%;
        position: relative;
        padding: 10px 20px;
    }

</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductForm',
    data () {
        return {
            user:{},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            products:{},
            post:{},
            gallery:{},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            action_loading:false,
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
        }
    },
    components: {
       
     },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        setComponent(attr1,attr2){
            
        },
        
        trackevent(e){
            // $('#category-type-3').disabled = true;
            if(e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined){
              this.category_type_2 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined){
              this.category_type_1 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined){
              this.category_type_1 = true;
              this.category_type_2 = true; 
            }
            else{
            this.category_type_1 = false;
              this.category_type_2 = false;
              this.category_type_3 = false;
             }
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.getSellpointCategories();
                        

                    }else {
                        // this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        // this.$router.push('login');
                    }
                })
            }else {
                // this.$router.push('login');
            }
        },

        getSellpointCategories(){
            service.getBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                   this.sellpoint = response.body.data;
                   //let sellpoint_data = response.body.data;
                    // service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                    //     if(response.body.status == 200) {
                    //         this.sellpoint_categories = response.body.data;
                    //     }
                    // }).catch((err) => {})
                    // this.getSubCategories(this.sellpoint.business_category_id);
                    // this.getSellpointProducts();
                }
            }).catch((err) => {
                //log it
               // this.$router.push("/")
            //    console.log(err)
            })

        },

        getSubCategories(category){
            service.getBusinessSubCategories(this, category).then(response => {
                if(response.body.status == 200) {
                    this.sub_categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSellpointProducts(){
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                }
            }).catch((err) => {})
                
        },

        addGallery(){
            // this.disable_btn = true;
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 1, //default post gallery
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description:this.gallery.gallery_description,
                gallery_post_group: 0, //no group as in new
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products:  [], 
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                         this.data_success_message =  "Post Created";
                        //log user in
                        this.post = data.body.data;
                        this.gallery = data.body.data_gallery;
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type","gallery_media");
                        let url = "/"+this.$route.params.id+"/g/"+this.gallery.gallery_posts_group_url_name;
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            this.data_media_error_message = "";
                            location.replace(url); 
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                                //console.log(err)
                                }
                            toastr.warning("Something went wrong.", 'Warning!');
                            this.data_error_message =  "Something went wrong";
                            this.deactivate_processing();
                        })

                        //if uploading takes time continue with reload //till client resize images
                        this.data_media_error_message = service.media_upload_timeout_msg;
                        let self = this;
                        setTimeout(function(){  self.data_media_error_message; }, 1200); //wait for 1min and timeout
                        setTimeout(function(){//wait for 1min
                            location.replace(url); 
                        }, 2000); 
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                       this.data_error_message =  "Something went wrong";
                       this.deactivate_processing();
                        // this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                // this.disable_btn = false;
                this.data_error_message =  "Kindly fill all fields";
                this.deactivate_processing();
            }
        },

   

    //uploads
    onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {   
            this.file_info = files;
            let formData = new FormData();
            formData.append('photo', files[0]); 
            this.imageForm = formData;
        }   
       
    },

},
    created: function(){
        this.preset();
    }
}

</script>


// WEBPACK FOOTER //
// newgallery.vue?86101126